import React ,{Suspense} from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Header from './Header.js'
import { RowAlertProvider } from './RowAlertProvider.js';
import { OptionsBasketProvider } from './OptionsBasketContext.js';
import OptionsBasketDrawer from './OptionsBasketDrawer.js';
import IntradayBaseAlert from './IntradayBaseAlert.js';
import ResultAnalysisAlert from './ResultAnalysisAlert.js';
import IndexNewsAlert from './IndexNewsAlert.js';
import GuidedDashboard from './pages/guidedDashboard.js';


const StockLinksPage = React.lazy(() => import('./pages/stock_links.js'))
const Fetchtickdata = React.lazy(() => import('./pages/Fetch_tick_Data.js'));
const BTSTPage = React.lazy(() => import('./pages/btst-data.js'));

const PostMsg = React.lazy(() => import('./pages/post_msg.js'));
const Flatcandle = React.lazy(() => import('./pages/flat_candle.js'))
const Card =  React.lazy(() => import('./pages/dashboard.js'))
const IndustryDashboard = React.lazy(() => import('./pages/dashboard_1.js'))
const FoDashboard = React.lazy(() => import('./pages/f_o_dashboard.js'))
const GainersLosersDashboard = React.lazy(() => import('./pages/gainers_losers_dashboard.js'))
const GainersLosersDashboardInd = React.lazy(() => import('./pages/gainers_losers_ind.js'))
const ResultImpactStrategy = React.lazy(() => import('./pages/result_impact.js'))
const StockDuraionStrategy = React.lazy(() => import('./pages/stock_duration .js'))
const FOStockDetails = React.lazy(() => import('./pages/f_o_stock_details.js'))
const FOListData = React.lazy(() => import('./pages/f_o_list.js'))
const StockMessages = React.lazy(() => import('./pages/stocknotifications.js'))
const FOWatchlist = React.lazy(() => import('./pages/watchlist.js'))
const Watchlist = React.lazy(() => import('./pages/all_stock_watchlist.js'))
const IndustryScores = React.lazy(() => import('./pages/f&o_industry.js'))
const Notification = React.lazy(() => import('./pages/f_o_stock_details.js'))
const PullbackData = React.lazy(() => import('./pages/pullback_strategy.js'))
const AlertStockDisplay = React.lazy(() => import('./pages/alert_stock_display.js'))
const NiftyDaily = React.lazy(() => import('./oldsite/nifty_daily.js'))
const IndustryTrendPage = React.lazy(() => import('./oldsite/industry_trend_page.js'))
const IndStockDetailsPage = React.lazy(() => import('./oldsite/indust_stock_details.js'))
const OsStockDetails = React.lazy(() => import('./oldsite/stock_detail.js'))
const FODetails = React.lazy(() => import('./oldsite/future_option.js'))
const InsiderTrading  = React.lazy(() => import('./oldsite/inside_strategy.js'))
const IndustryDetails = React.lazy(() => import('./oldsite/industryDetailsPage.js'))
const Strategy  = React.lazy(() => import('./oldsite/strategy.js'))
const Stage  = React.lazy(() => import('./oldsite/stage.js'))
const IndexContributor = React.lazy(() => import('./pages/index_contributor.js'))
const IndexAtmDashboard = React.lazy(() => import('./pages/atm_dashboard/index_atm_dashboard.js'))
const PremiumAnalysis = React.lazy(() => import('./pages/premium_analysis/premium_analysis.js'))
const WeekhighStock = React.lazy(() => import('./pages/weekhigh_stock.js'))
const WeeklowStock = React.lazy(() => import('./pages/weeklow_stock.js'))
const OptionsDataTable = React.lazy(() => import('./pages/option_chain_pro.js'))
const StockOptions = React.lazy(()=> import('./pages/options.js'))
const INDEX_STOCK_OPTIONS = React.lazy(() => import('./pages/option_page.js'))
const PatternStock = React.lazy(() => import('./pages/pattern_stock.js'))
const OIhigh = React.lazy(() => import('./pages/oi_high.js'))
const StockTickerGrid = React.lazy(() => import('./pages/stock_timeseriesdata.js'))
const VrSrBlast = React.lazy(() => import('./pages/vr_sr_blast.js')) 
const TickerRanksTable = React.lazy(() => import('./pages/stock_rank.js')) 
const StockRanklive = React.lazy(() => import('./pages/Rankchange.js')) 
const MomentumStock = React.lazy(() => import('./pages/momentum_stock.js'))
const SectorRankHistory = React.lazy(() => import('./pages/sectorRankchange.js'))
const VolumeBlastMomentumStock = React.lazy(() => import('./pages/vol_blast_momentum_stck.js'))
const SectorPerformanceHeatmap = React.lazy(() => import('./pages/sectorheatmap.js'))
const StockRankhistory = React.lazy(() => import('./pages/stockRankhistory.js'))
const StockLog = React.lazy(() => import('./pages/log.js'))
const TrendingstockDashboard = React.lazy(() => import('./pages/recent_trendingstock.js'))
const TopGainerDetails = React.lazy(() => import('./pages/top_stock_detail.js'))
const PremarketTopGL = React.lazy(() => import('./pages/premarket_top_gl.js'))
const CandlestickChart = React.lazy(() => import('./pages/candlestick_chart.js'))
const KiteChart = React.lazy(() => import('./pages/test_kite.js'))
const ResultAnalysis = React.lazy(() => import('./pages/result_analysisi.js'))
const QueryPage = React.lazy(() => import('./pages/stock_filter.js'))
const DrawdownChanges = React.lazy(() => import('./pages/drawdown_changes.js'))
const PortfolioLayout = React.lazy(() => import('./pages/portfolio_layout.js'))
const PortfolioDashboard = React.lazy(() => import('./pages/portfolio_dashboard.js'))
const PortfolioHoldings = React.lazy(() => import('./pages/portfolio_holdings.js'))
const PortfolioPositions = React.lazy(() => import('./pages/portfolio_positions.js'))
const OrdersUnified = React.lazy(() => import('./pages/orders_unified.js'))
const AthTestingTable = React.lazy(() => import('./pages/ath_testing.js'))
const HarmonicPatternTable = React.lazy(() => import('./pages/harmonic_pattern.js'))
const KiteFetchPage = React.lazy(() => import('./pages/kite_fetch_page.js'))
const ExcelSheetPage = React.lazy(() => import('./pages/excel_sheet_page.js'))
const AdvancedQueryPage = React.lazy(() => import('./pages/advanced_query_page.js'))
const SectorMomentum = React.lazy(() => import ('./pages/sector_dashboard.js'))
const Admin = React.lazy(() => import('./pages/admin.js'))
const BacktestSimulator = React.lazy(() => import('./pages/orders.js'))
const IntradayBase = React.lazy(() => import('./pages/sector_momentum/first_5min_candle_bo.js'))
const Indices = React.lazy(() => import('./pages/indices.js'))
const IndicesOneMin = React.lazy(() => import('./pages/indices_1min.js'))
const Indices15s = React.lazy(() => import('./pages/indices_15s.js'))




function App() {
  return (
    <Router>
      <OptionsBasketProvider>
      <div>
        {/* <ApiPollingAlert
          apiUrl="https://live1.finstrats.com/alert_notification"
          pollingInterval={30000}
        /> */}
        <RowAlertProvider>
          {/* Temporarily disabled — chime/toast notifications stopped */}
          {/* <IntradayBaseAlert /> */}
          {/* <ResultAnalysisAlert /> */}
          {/* IndexNewsAlert temporarily disabled — stop news toast/chime notifications */}
          {/* <IndexNewsAlert /> */}
        </RowAlertProvider>
        <Header />
        <Toaster position="top-right" />
        <Suspense>
          <Routes>
            <Route path="/kite_graph_data" element={<KiteChart />} />
            <Route path="/card" element={<Card />} />
            <Route path="/highvolume" element={<StockLinksPage />} />
            <Route path="/fetch-data" element={<Fetchtickdata />} />
            <Route path="/btst-data" element={<BTSTPage />} />
            <Route path="/flat_candle" element={<Flatcandle />} />
            <Route path="/post" element={<PostMsg />} />
            <Route path="/industry" element={<IndustryDashboard />} />
            <Route path="/f_o_dashboard" element={<FoDashboard />} />
            <Route path="/" element={<GainersLosersDashboard/>} />
            <Route path="/gainers_losers_ind" element={< GainersLosersDashboardInd/>} />
            <Route path= "/strategies_res" element={<ResultImpactStrategy />}/>
            <Route path= "/strategies_duration" element={<StockDuraionStrategy />}/>
            <Route path= "/f_o_stocks_details" element={<FOStockDetails />}/>
            <Route path ="/f_o_listdata" element = {<FOListData/>}/>
            <Route path ="/notification" element = {<StockMessages/>}/>
            <Route path ="/f_o_watchlist" element = {<FOWatchlist/>}/>
            <Route path ="/watchlist" element = {<Watchlist/>}/>
            <Route path ="/f_o_industry_score" element = {<IndustryScores/>}/>
            <Route path ="/test" element = {<Notification/>}/>
            <Route path ="/pullback" element = {<PullbackData/>}/>
            <Route path ="/alert_stock" element = {<AlertStockDisplay/>}/>
            <Route path ="/index_contributor" element = {<IndexContributor/>}/>
            <Route path ="/index_atm_dashboard" element = {<IndexAtmDashboard/>}/>
            <Route path ="/premium_analysis" element = {<PremiumAnalysis/>}/>
            <Route path ="/weekhigh_stock" element = {<WeekhighStock/>}/>
            <Route path ="/weeklow_stock" element = {<WeeklowStock/>}/>
            <Route path ="/optionchain" element = {<OptionsDataTable/>}/>
             <Route path ="/stock_options" element = {<StockOptions/>}/>
            <Route path ="/options" element = {<INDEX_STOCK_OPTIONS/>}/>
            <Route path ="/candle_pattern" element = {<PatternStock/>}/>
            <Route path ="/highoi" element = {<OIhigh/>}/>
            <Route path ="/stock_timeseries" element = {<StockTickerGrid/>}/>
            <Route path ="/vol_blast" element = {<VrSrBlast/>}/>
            <Route path = "/guided_data" element = {<GuidedDashboard/>} />
            <Route path ="/stock_rank" element = {<TickerRanksTable/>} />
            <Route path ="/rank_change" element = {<StockRanklive/>}/>
            <Route path ="/momentum_stock" element = {<MomentumStock/>}/>
            <Route path ="/sector_heatmap" element = {<SectorPerformanceHeatmap/>}/>
            <Route path ="/sector_rank_change" element = {<SectorRankHistory/>}/>
            <Route path ="/stock_rank_change" element = {<StockRankhistory/>}/>
            <Route path ="/volume_blast_intraday" element = {<VolumeBlastMomentumStock/>}/>
            <Route path ="/tradelog" element = {<StockLog/>}/>
            <Route path ="/trendingstock" element = {<TrendingstockDashboard/>}/>
            <Route path ="/gainersdetails" element = {<TopGainerDetails/>}/>
            <Route path ="/premarket_top_gl" element = {<PremarketTopGL/>}/>
            <Route path ="/day_chart" element = {<CandlestickChart/>}/>
            <Route path ="/result_analysis" element = {<ResultAnalysis/>}/>
            <Route path ="/drawdown_changes" element = {<DrawdownChanges/>}/>
            <Route path ="/filter-with-query" element = {<QueryPage/>}/>
            <Route path ="/ath_testing" element = {<AthTestingTable/>}/>
            <Route path ="/harmonic_pattern" element = {<HarmonicPatternTable/>}/>
            <Route path ="/data-tools/kite-fetch" element = {<KiteFetchPage/>}/>
            <Route path ="/data-tools/excel-sheet" element = {<ExcelSheetPage/>}/>
            <Route path ="/data-tools/advanced-query" element = {<AdvancedQueryPage/>}/>

            {/* old site url */}
            <Route path ="/market" element = {<NiftyDaily/>}/>
            <Route path ="/industry_trend" element = {<IndustryTrendPage/>}/>
            <Route path ="/stockdetails" element = {<IndStockDetailsPage/>}/>
            <Route path ="/stocks" element = {<OsStockDetails/>}/>
             <Route path ="/f_o" element = {<FODetails/>}/>
            <Route path ="/insider" element = {<InsiderTrading/>}/>
            <Route path = "/industry_details" element={<IndustryDetails />} />
            <Route path = "/strategy" element={<Strategy />} />
            <Route path = "/stage" element={<Stage />} />
            <Route path = "/intraday_base" element={<IntradayBase />} />
            <Route path = "/index" element={<Indices />} />
            <Route path = "/index_1min" element={<IndicesOneMin />} />
            <Route path = "/15s_index" element={<Indices15s />} />
{/* 
            {/* Portfolio Routes */}
            <Route path="/portfolio" element={<PortfolioLayout />}>
              <Route index element={<PortfolioDashboard />} />
              <Route path="holdings" element={<PortfolioHoldings />} />
              <Route path="positions" element={<PortfolioPositions />} />
              <Route path="orders" element={<OrdersUnified />} />
              <Route path="basket" element={<OrdersUnified />} />
              <Route path="ato" element={<OrdersUnified />} />
              <Route path="tracking" element={<BacktestSimulator />} />
            </Route>

            <Route path ="/sector_momentum" element={<SectorMomentum />} />
            {/* Moved under /portfolio so it shares the account selector + sidebar; redirect keeps old links working. */}
            <Route path='/tracking-orders' element={<Navigate to="/portfolio/tracking" replace />} />
            <Route path="/admin" element={<Admin />} />

             
          </Routes>
        </Suspense>
        <OptionsBasketDrawer />
      </div>
      </OptionsBasketProvider>
    </Router>
  );
}

export default App;



// import React, { Suspense } from 'react';
// import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

// import Header from './Header.js'

// const StockLinksPage = React.lazy(() => import('./pages/stock_links.js'))
// const Fetchtickdata = React.lazy(() => import('./pages/Fetch_tick_Data.js'));
// const BTSTPage = React.lazy(() => import('./pages/btst-data.js'));
// const Indices = React.lazy(() => import('./pages/indices.js'));
// const PostMsg = React.lazy(() => import('./pages/post_msg.js'));
// const Flatcandle = React.lazy(() => import('./pages/flat_candle.js'))
// const Card = React.lazy(() => import('./pages/dashboard.js'))

// // Create a layout component to conditionally render Header
// const Layout = ({ children }) => {
//   const location = useLocation();
  
//   return (
//     <>
//       {location.pathname !== '/dashboard' && <Header />}
//       {children}
//     </>
//   );
// };

// function App() {
//   return (
//     <Router>
//       <Layout>
//         <Suspense>
//           <Routes>
//             <Route path="/" element={<StockLinksPage />} />
//             <Route path="/fetch-data" element={<Fetchtickdata />} />
//             <Route path="/btst-data" element={<BTSTPage />} />
//             <Route path="/flat_candle" element={<Flatcandle />} />
//             <Route path="/index" element={<Indices />} />
//             <Route path="/post" element={<PostMsg />} />
//             <Route path="/dashboard" element={<Card />} />
//           </Routes>
//         </Suspense>
//       </Layout>
//     </Router>
//   );
// }

// export default App;
